import React from 'react';
import './button.css';

const Button = ({ id = "", icon = "", label, onClick, type = 'primary', className = '' }) => {
  return (
    <button
      id={id}
      className={`button ${type} ${className}`}
      onClick={onClick}
    >
      {icon}
      {label}
    </button>
  );
};

export default Button;
